<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.75C6.75736 2.75 5.75 3.75736 5.75 5V6.5C5.75 7.74264 6.75736 8.75 8 8.75C9.24264 8.75 10.25 7.74264 10.25 6.5V5C10.25 3.75736 9.24264 2.75 8 2.75Z"
      :stroke="color"
    />
    <path
      d="M10.25 6.5C10.25 8.375 10.01 9.8 7.45 11C4.89 12.2 4.25 13.875 4.25 14.75"
      :stroke="color"
    />
    <path d="M5.75 5H10.25" :stroke="color" stroke-linecap="round" />
    <path
      d="M12.3516 4.63898C12.3516 2.35309 10.4033 0.5 8 0.5C5.59666 0.5 3.64836 2.35309 3.64836 4.63898C3.64836 6.21244 3.09494 9.10185 1.2938 11.3262C0.733286 12.0184 0.453027 12.3645 0.50644 12.683C0.559853 13.0016 0.860026 13.1966 1.46037 13.5867C5.38678 16.1378 10.6132 16.1378 14.5396 13.5867C15.14 13.1966 15.4401 13.0016 15.4936 12.683C15.547 12.3645 15.2667 12.0184 14.7062 11.3262C12.9051 9.10185 12.3516 6.21244 12.3516 4.63898Z"
      :stroke="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
